import React from 'react';
import { GiCommercialAirplane, GiHouse } from 'react-icons/gi';
import { useParams } from 'react-router-dom';
import Detail from '../components/pages/detail';
import DetailComponent from '../components/details/flight_schedule';
export default () => {
    const {id} = useParams();
    
    return (
        <Detail 
            title={`flight_schedule`} 
            icon={GiCommercialAirplane} 
            id={id}
            url={`api/v1/flight_schedule/international/any/detail`}
            getBreadcumbValue={({flight_number})=>flight_number}
            breadcrumbs={
                [
                    {
                        href:'/home',
                        icon:<GiHouse color='white' />,
                        item:'home'
                    },
                    {
                        item:'flight_schedule'
                    },
                ]
            }
            DetailComponent={DetailComponent}
            additionalData={{id}}
        />
    )
}